type Answer = {
  value: string[];
  title: string;
};

export type Answers = {
  question1: Answer;
  question2: Answer;
  question3: Answer;
  question4: Answer;
  question5: Answer;
};

export type Fields = {
  date?: Date; // FIXME: validationSchemaで怒られるため、?を入れてる
  startTime: string;
  endTime: string;
  prescriptions?: File[]; // FIXME: validationSchemaで怒られるため、?を入れてる
  familyName: string;
  givenName: string;
  phoneticFamilyName: string;
  phoneticGivenName: string;
  birthDate: string;
  sex: string;
  mobilePhone: string;
  answers: Answers;
  isAgreed: boolean;
};

export const StepNameMap = {
  time: "time",
  prescription: "prescription",
  patientInfo: "patientInfo",
  questionnaire: "questionnaire",
  complete: "complete",
};

export type StepName = (typeof StepNameMap)[keyof typeof StepNameMap];
